import css from 'styled-jsx/css';
import { colors, typography, zIndex } from '../../../../config/styles';
import { svgUrl } from '../../../../utils/staticUrls';

export const SellerInfoDesktopStyle = css`
  /* Block: Main seller info component */
  .seller-info {
    display: flex;
    align-items: baseline;
    flex-direction: column;
  }

  /* Element: Container for seller information */
  .seller-info__container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: ${colors.gray.shade15};
    letter-spacing: 0.14px;
    font-size: ${typography.sm1};
    line-height: ${typography.xla};
    width: 100%;
  }

  /* Element: Label text */
  .seller-info__label {
    color: inherit;
  }

  /* Element: Seller link */
  .seller-info__link {
    text-decoration: none;
    background-color: transparent;
    color: inherit;
  }

  /* Element: Seller name with underline */
  .seller-info__seller-name {
    border-bottom: 0.5px solid ${colors.gray.shade15};
    text-transform: capitalize;
  }

  /* Element: Seller icons base styles */
  .seller-info__icon {
    background-repeat: no-repeat;
    display: inline-block;
    vertical-align: middle;
    margin-left: 2px;
    margin-right: 6px;
  }

  /* Element Modifier: Falabella icon */
  .seller-info__icon--falabella {
    background-image: url(${svgUrl('falabella.svg')});
    height: 18px;
    width: 12px;
  }

  /* Element Modifier: Sodimac and Homecenter icons */
  .seller-info__icon--sodimac,
  .seller-info__icon--homecenter {
    background-image: url(${svgUrl('sodimac.svg')});
    height: 18px;
    width: 18px;
    align-self: flex-end;
  }

  /* Element Modifier: Tottus icon */
  .seller-info__icon--tottus {
    background-image: url(${svgUrl('tottus.svg')});
    height: 18px;
    width: 18px;
  }

  /* Element Modifier: Linio icon */
  .seller-info__icon--linio {
    background-image: url(${svgUrl('linio.svg')});
    height: 18px;
    width: 18px;
  }

  /* Element: Alert icon for tooltip */
  .seller-info__alert-icon {
    cursor: pointer;
    display: inline-block;
    transform: rotate(180deg);
    margin-left: 5px;
    color: ${colors.gray.shade19};
    font-size: ${typography.sm};
    z-index: ${zIndex.popover.content};

    &:hover {
      color: ${colors.green.shade1};
    }
  }

  /* Block Modifier: Rebranded styling */
  .seller-info--rebranded {
    .seller-info__alert-icon {
      color: ${colors.gray.shade45};

      &:hover {
        color: ${colors.gray.shade45};
      }
    }
  }

  /* Block Modifier: Out of stock state */
  .seller-info--out-of-stock {
    .seller-info__container {
      width: 300px;
      border-top: 1px solid ${colors.gray.shade3};
      border-bottom: 1px solid ${colors.gray.shade3};
    }
  }

  /* Tooltip content styling (external element) */
  #seller-tooltip-text {
    color: #767676;
  }
`;
